<div class="w-100 mr-2 progress">
    <div
        class="d-flex progress-bar"
        [class.progress-bar--danger]="barStyle === 'danger'"
        [class.progress-bar--warn]="barStyle === 'warn'"
        [class.progress-bar--secondary]="barStyle === 'secondary'"
        role="progressbar"
        [style.width]="progress + '%'"
    ></div>
</div>